<template>
  <v-container fluid class="px-6">
    <h4>
      Enforce Suffix of one hierarchy based on another e.g. append job level at end of job title etc
    </h4>
    <v-container v-if="hierarchyTypes">
      <v-divider class="mb-2" />
      <v-row class="mb-1">
        <v-col cols="3"><h4>Hierarchy Type</h4></v-col>
        <v-col cols="4"><h4>Suffixed With</h4></v-col>
        <v-col cols="4"><h4>Suffix Level</h4></v-col>
        <v-col cols="1"><v-btn color="primary" outlined @click="add">Add New</v-btn></v-col>
      </v-row>
      <v-divider class="mb-2" />
      <v-row
        v-for="ht in hierarchyTypes"
        :key="'e' + ht.ht_id"
        @click="edit(ht)"
        style="cursor: pointer"
      >
        <v-col cols="3">
          {{ ht.ht_name }}</v-col>
        <v-col cols="4">
          {{ ht.suffix_ht_name}}
        </v-col>
        <v-col cols="4">
          {{ ht.suffix_level }}
        </v-col>
        <v-col cols="1"
          ><v-btn small outlined @click="edit(ht)">Edit</v-btn></v-col
        >
      </v-row>
    </v-container>

    <v-dialog v-model="showEdit" max-width="800px">
      <v-card v-if="hierarchyTypeSuffix">
        <v-card-title>
          Pick a default value to hide
          {{ hierarchyTypeSuffix.ht_name }} for this template
          <v-spacer />
          <v-btn icon @click="showEdit = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-select
                v-model="hierarchyTypeSuffix.ht_id"
                :items="hierarchies"
                item-text="ht_name"
                item-value="ht_id"
                label="Hierarchy Type"
                class="roundish"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="hierarchyTypeSuffix.suffix_ht_id"
                :items="hierarchies"
                item-text="ht_name"
                item-value="ht_id"
                label="Suffix Hierarchy Type"
                class="roundish"
                outlined
                dense
                clearable
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="hierarchyTypeSuffix.suffix_level"
                v-if="hierarchyTypeSuffix.suffix_ht_id"
                label="Suffix Level"
                type="number"
                class="roundish"
                outlined
                dense
                clearable>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end pr-6 pb-4">
          <v-btn
            v-if="hierarchyTypeSuffix.tmpl_hierarchy_suffix_id"
            color="error"
            @click="deleteItem"
            outlined
            >Delete</v-btn
          ><v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="showEdit = false">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Loading :isVisible="isLoading" />
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
  </v-container>
</template>

<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler";
import { mapState } from "vuex";

export default {
  name: "cTemplateBuilderHierarchyHidden",
  components: {
    ResponseHandler,
  },
  props: {
    value: { type: Number, required: false },
  },
  data: function () {
    return {
      isLoading: false,
      response: null,
      hierarchyTypes: [],
      hierarchyTypeSuffix: null,
      showEdit: false,
      hierarchies: [],
    };
  },
  mounted() {},
  created() {
    if (!this.hierarchiesLoading) this.init();
  },
  watch: {
    value() {
      this.init();
    },
  },
  computed: {
    ...mapState({
      hierarchiesLoading: (state) => state.hierarchies.loading,
    }),
    saveEEnabled() {
      if (!this.hierarchyTypeSuffix) return false;

      if (!this.hierarchyTypeSuffix.ht_id) return false;

      return true;
    },
  },
  methods: {
    sessionExpired(err) {
      this.$emit("sessionExpired", err);
    },
    init() {
      let possibleError = false;
      this.isLoading = true;
      if (
        !this.$store.state.hierarchies.loading &&
        this.$store.state.hierarchies.hierarchies.length
      ) {
        this.hierarchies = JSON.parse(
          JSON.stringify(this.$store.state.hierarchies.hierarchies)
        );
      }
      axios
        .get("templateBuilder/templateHierarchySuffix/" + this.value)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            const data = resp.data.Data;

            this.hierarchyTypes = data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    edit(item) {
      this.hierarchyTypeSuffix = JSON.parse(JSON.stringify(item));
      this.hierarchyTypeSuffix.hide_in_picker =
        Number(this.hierarchyTypeSuffix.hide_in_picker) > 0;
      this.showEdit = true;
    },
    add() {
      this.hierarchyTypeSuffix = {
        ht_id: null,
        tmpl_id: this.value,
        suffix_ht_id: null,
        suffix_level: null,
      };
      this.showEdit = true;
    },
    save() {
      if (!this.hierarchyTypeSuffix) return;
      let possibleError = false;
      this.isLoading = true;
      if (!this.hierarchyTypeSuffix.suffix_ht_id) {
        this.hierarchyTypeSuffix.suffix_level = null;
      }
      axios
        .post(
          "templateBuilder/saveTemplateHierarchySuffix",
          this.hierarchyTypeSuffix
        )
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (this.hierarchyTypeSuffix.tmpl_hierarchy_suffix_id) {
              let index = this.hierarchyTypes.findIndex(
                (x) => x.tmpl_hierarchy_suffix_id === this.hierarchyTypeSuffix.tmpl_hierarchy_suffix_id
              );
              this.hierarchyTypes.splice(index, 1, resp.data.Data);
            } else {
              this.hierarchyTypes.push(resp.data.Data);
            }
            
            this.showEdit = false;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    deleteItem() {
      if (!this.hierarchyTypeSuffix) return;

      if (confirm(`Delete ${this.hierarchyTypeSuffix.ht_name} Suffix?`)) {
        this.hierarchyTypeSuffix.suffix_ht_id = null;
        this.hierarchyTypeSuffix.suffix_level = null;
        
        let possibleError = false;
        this.isLoading = true;
        axios
        .post(
          "templateBuilder/deleteTemplateHierarchySuffix",
          this.hierarchyTypeSuffix
        )
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            let index = this.hierarchyTypes.findIndex(
              (x) => x.ht_id === this.hierarchyTypeSuffix.ht_id
            );
            this.hierarchyTypes.splice(index, 1);
            this.showEdit = false;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/vars";

.draghandle {
  cursor: move;
}
</style>